import ProductView from 'src/sections/management/product/view/product-view';

export default function Product() {
  return <ProductView />;
}
